import React, { useMemo } from "react";
import axios from "axios";
import {
  Box, Paper, Table, TableBody, TableContainer, TableHead,
  TablePagination, TableRow, Button, IconButton, Tooltip, Chip
} from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import { useState } from "react";
import CustomTableCell from "../../shared/CustomTable/CustomTableCell";

const API_BASE = process.env.REACT_APP_API;
const LIST_URL = `${API_BASE}/announcements/all`;

export default function AnnouncementsTable({ onEdit, changed, onChanged }) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  // fetch simples (padrão do projeto usa hook; aqui deixei embutido)
  React.useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        setLoading(true);
        const { data } = await axios.get(LIST_URL);
        if (mounted) setData(Array.isArray(data) ? data : []);
      } catch (e) {
        console.error("GET /announcements/all failed", e);
      } finally {
        setLoading(false);
      }
    })();
    return () => (mounted = false);
  }, [changed]);

  const pageData = useMemo(() => {
    const start = page * rowsPerPage;
    return data.slice(start, start + rowsPerPage);
  }, [data, page, rowsPerPage]);

  const handleChangePage = (_, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (e) => {
    setRowsPerPage(+e.target.value);
    setPage(0);
  };

  const activate = async (id) => {
    try {
      await axios.patch(`${API_BASE}/announcements/set-current/${id}`);
      onChanged();
    } catch (e) {
      console.error("PATCH set-current failed", e);
    }
  };
  const deactivate = async (id) => {
    try {
      await axios.patch(`${API_BASE}/announcements/set-not-current/${id}`);
      onChanged();
    } catch (e) {
      console.error("PATCH set-not-current failed", e);
    }
  };

  return (
    <Box sx={{ width: "100%", p: 1 }}>
      <Paper sx={{ width: "100%", overflow: "hidden" }}>
        <TableContainer sx={{ overflow: "auto", height: "70vh" }}>
          <Table stickyHeader sx={{ width: "100%" }}>
            <TableHead>
              <TableRow>
                <CustomTableCell>ID</CustomTableCell>
                <CustomTableCell>Nome</CustomTableCell>
                <CustomTableCell>Template</CustomTableCell>
                <CustomTableCell>Status</CustomTableCell>
                <CustomTableCell align="center">Ação</CustomTableCell>
                <CustomTableCell align="center">Editar</CustomTableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {pageData.map((row) => {
                const isCurrent = String(row?.is_current || "").toUpperCase() === "Y";
                return (
                  <TableRow key={row.id} hover>
                    <CustomTableCell>{row.id}</CustomTableCell>
                    <CustomTableCell>{row.name}</CustomTableCell>
                    <CustomTableCell>{(row.template_key || "").toUpperCase()}</CustomTableCell>
                    <CustomTableCell>
                      {isCurrent ? (
                        <Chip color="success" size="small" label="Ativo" />
                      ) : (
                        <Chip color="default" size="small" label="Inativo" />
                      )}
                    </CustomTableCell>
                    <CustomTableCell align="center">
                      {isCurrent ? (
                        <Tooltip title="Desativar">
                          <IconButton onClick={() => deactivate(row.id)}>
                            <CancelOutlinedIcon color="error" />
                          </IconButton>
                        </Tooltip>
                      ) : (
                        <Tooltip title="Tornar ativo">
                          <IconButton onClick={() => activate(row.id)}>
                            <CheckCircleOutlineIcon color="success" />
                          </IconButton>
                        </Tooltip>
                      )}
                    </CustomTableCell>
                    <CustomTableCell align="center">
                      <Button onClick={() => onEdit(row)}>
                        <EditOutlinedIcon />
                      </Button>
                    </CustomTableCell>
                  </TableRow>
                );
              })}

              {(!loading && pageData.length === 0) && (
                <TableRow>
                  <CustomTableCell colSpan={6} align="center">
                    Nenhum anúncio encontrado.
                  </CustomTableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          labelRowsPerPage="Registros por página"
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={data.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          sx={{ fontSize: "12px" }}
        />
      </Paper>
    </Box>
  );
}
